import { render, staticRenderFns } from "./SchoolCard.vue?vue&type=template&id=cd8fa1d4&"
import script from "./SchoolCard.vue?vue&type=script&lang=ts&"
export * from "./SchoolCard.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolCard.vue?vue&type=style&index=0&id=cd8fa1d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports